"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveManager = void 0;
var live_stream_1 = require("./metadata/live-stream");
var live_stream_analytics_1 = require("./metadata/live-stream-analytics");
var live_stream_list_response_1 = require("./responses/live-stream-list-response");
/**
 * @param {Configuration} configuration
 * @param {HTTPClient} httpClient
 * @constructor
 */
var LiveManager = /** @class */ (function () {
    function LiveManager(configuration, httpClient) {
        this.configuration = configuration;
        this.httpClient = httpClient;
        /**
         * @type {string}
         */
        this.baseUrl = 'https://' + configuration.domain;
        /**
         * @type {string}
         */
        this.apiUrl = this.baseUrl + '/_api/live';
    }
    /**
     * Open stream
     * @param {LiveStreamRequest} liveStreamRequest
     * @returns {Promise<LiveStream>}
     */
    LiveManager.prototype.openStream = function (liveStreamRequest) {
        return this.httpClient
            .post(this.apiUrl + '/streams', liveStreamRequest)
            .then(function (response) {
            return new live_stream_1.LiveStream(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * Get stream
     * @param {string} streamId
     * @returns {Promise<LiveStream>}
     */
    LiveManager.prototype.getStream = function (streamId) {
        return this.httpClient
            .get(this.apiUrl + '/streams/' + streamId)
            .then(function (response) {
            return new live_stream_1.LiveStream(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * Get stream
     * @param {string} streamId
     * @returns {Promise<LiveStreamAnalytics>}
     */
    LiveManager.prototype.getStreamAnalytics = function (streamId) {
        return this.httpClient
            .get(this.apiUrl + '/streams/' + streamId + '/analytics')
            .then(function (response) {
            return new live_stream_analytics_1.LiveStreamAnalytics(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * Close stream
     * @param {string} streamId
     * @returns {Promise<void>}
     */
    LiveManager.prototype.closeStream = function (streamId) {
        return this.httpClient
            .delete(this.apiUrl + '/streams/' + streamId)
            .catch(function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * List streams
     * @param {LiveStreamListRequest} liveStreamListRequest
     * @returns {Promise<LiveStreamListResponse>}
     */
    LiveManager.prototype.listStreams = function (liveStreamListRequest) {
        var params = liveStreamListRequest && liveStreamListRequest.toParams();
        return this.httpClient
            .get(this.apiUrl + '/streams', params)
            .then(function (response) {
            return new live_stream_list_response_1.LiveStreamListResponse(response.payload);
        }, function (error) {
            return Promise.reject(error);
        });
    };
    /**
     * Get URL of stream cover
     * @param {string} streamId
     * @returns {Promise<string>}
     */
    LiveManager.prototype.getStreamCoverUrl = function (streamId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.addAuthToUrl(this.apiUrl + ("/streams/" + streamId + "/frame"))];
            });
        });
    };
    return LiveManager;
}());
exports.LiveManager = LiveManager;
//# sourceMappingURL=live-manager.js.map